<eo-base-form-control
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
>
  <p-autoComplete
    [id]="id"
    [tabindex]="getTabIndex()"
    [appendTo]="getAppendTo()"
    attr.aria-describedby="{{ id }}-help"
    styleClass="w-full {{ getInputStyleClass() }}"
    (loadingPlaceholder)="getLoadingPlaceholder()"
    [formControl]="getFormControl()"
    [suggestions]="getSuggestions()"
    [showClear]="getShowClear()"
    (completeMethod)="filterSuggestions($event)"
    [optionLabel]="getOptionLabel()"
    [field]="getOptionValue()"
    [showEmptyMessage]="getShowEmptyMessage()"
    [emptyMessage]="getEmptyMessage()"
    [placeholder]="getPlaceholder()"
    [minLength]="getMinLength()"
    [maxlength]="getMaxLength()"
    [multiple]="getMultiple()"
    (onChange)="change.emit($event)"
    (onFocus)="focus.emit($event)"
    (onBlur)="blur.emit($event)"
    (onSelect)="select.emit($event)"
  >
    <ng-content />
  </p-autoComplete>
</eo-base-form-control>
